import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {BannerCheckbox} from 'onboarding/ClientBanner';

export default function GenentechPTDBanner(props: {
  showRequiredCheckbox: boolean;
  isChecked: boolean;
  setIsChecked: (checked: boolean) => void;
}): JSX.Element {
  return (
    <div className={css(styles.bodyText)}>
      <p>
        I acknowledge that I am bound by confidentiality obligations imposed through my employment or
        contractual agreement with Roche in connection with my access to confidential information, including
        PTD Non-GMP ELN-Benchling and its contents. By entering PTD Non-GMP ELN-Benchling, I confirm that I
        understand that my activities within PTD Non-GMP ELN-Benchling may be monitored consistent with local
        law, and all contents and passwords are confidential information, and that unauthorized disclosure or
        use of such confidential information may result in disciplinary action including termination of my
        employment or services and/or legal action based on local law.
      </p>
      {props.showRequiredCheckbox && (
        <BannerCheckbox
          isChecked={props.isChecked}
          setIsChecked={props.setIsChecked}
          labelText="I acknowledge the obligations as stated above"
        />
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  bodyText: {
    fontSize: 15,
  },
});
